import { capitalize } from 'vue';

import CreativeOrientationType from '@/common/enums/CreativeOrientationType.enum';
import i18n from '@/vueI18n';

export default class CreativeOrientationOptions {
  static options() {
    return [
      {
        id: CreativeOrientationType.Landscape,
        name: capitalize(i18n.global.t('names.orientationLandscape', { n: 1 })),
      },
      {
        id: CreativeOrientationType.Portrait,
        name: capitalize(i18n.global.t('names.orientationPortrait', { n: 1 })),
      },
      {
        id: CreativeOrientationType.Square,
        name: capitalize(i18n.global.t('names.orientationSquare', { n: 1 })),
      },
    ];
  }
}
